module.exports = __webpack_public_path__ + "static/media/new_member_event.e8af7f50.png";